export default function myCertificates() {
    return {
        awardedCertificates: [],
        candidacies: [],

        peopleCodeId: '',
        message: '',
        formatDate(dateValue) {
            if (dateValue != undefined && dateValue != "" && dateValue != null && dateValue != "N/A" && dateValue != 0) {
                const date = new Date(dateValue);
                const month = date.getMonth() + 1; // Month is zero-based, so add 1
                const day = date.getDate();
                const year = date.getFullYear();
                return `${month}/${day}/${year}`;
            }
            else {
                return dateValue;
            }
        },
        bindCandidacies() {
            fetch('/api/StudentAPI/GetCandidacies', { "method": "GET" })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {

                    if (response != undefined && response.isSuccess) {
                        this.candidacies = response.certificates;

                    } else {
                        this.showErrorMesage = "An unknown error has occurred. Please try again later."
                    }

                });
        },

        bindAwarededCertificates() {
            fetch('/api/StudentAPI/GetAwardedCertificates', { "method": "GET" })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {

                    if (response != undefined && response.isSuccess) {
                        this.awardedCertificates = response.certificates;

                    } else {
                        this.showErrorMesage = "An unknown error has occurred. Please try again later."
                    }

                });

        },


        init() {
            this.bindCandidacies();
            this.bindAwarededCertificates();
        }


    }
}